module.exports = __webpack_public_path__ + "static/media/Slide42.835b8a50.JPG";